import BuildingGroupIcon from '../../../icons/buildings-group.svg'

function toBuildingGroupAsyncMultiValuedListMoreItem(item) {
  return {
    Icon: BuildingGroupIcon,
    children: item.name,
    src: item.avatar,
  }
}

export function getDataItems(response) {
  return response.data.items.map(toBuildingGroupAsyncMultiValuedListMoreItem)
}
